import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M21.5 7h-5.689a2 2 0 0 0-1.834 1.203l-3.954 9.095A2 2 0 0 1 8.189 18.5H3.5M21.5 7l-3 3m3-3-3-3m3 13.5h-5.689a2 2 0 0 1-1.834-1.203L13.5 15.2m8 2.3-3-3m3 3-3 3M3.5 6h4.689a2 2 0 0 1 1.834 1.203l.727 1.672"
    }, null, -1)
  ])))
}
export default { render: render }